module.exports = __webpack_public_path__ + "img/mavent.fa4db2f0.svg";